import { getValueAtPath } from "../../../../../utils";
import SuccessView from "../../../common/success";
import PendingView from "../../../common/pending";
import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const $this = this;
  const { $charge, $timer } = this;

  $this.pollConfig = {
    onBegin() { $timer.start() },
    onCancel() { $this.pollConfig.onComplete() },
    onFailure(data) {
      /* self.console.log(data); */
    },
    onSuccessful() { SuccessView && SuccessView.activate.call($this) },
    onComplete() { ($this.TRANSFER_DETAILS = null, $timer.clear() /*, self.console.log({ ...$this }) */) }
  }

  return (view = ViewFactory({
    NAME: 'BANK_TRANSFER_DETAILS_VIEW',
    mutables: { timerCurrent: 'CURRENT_TIME' },
    constants: {
      get details() { return $this.TRANSFER_DETAILS },
      instruction: 'Proceed to your bank app to complete this transfer',
      get timerDuration() { return $timer.duration }
    },
    next() {
      const hasStartedPolling = getValueAtPath($this, 'STATE.backgroundProcessing');
      const currency = getValueAtPath($this, 'STATE.currency.current') || 'NGN';
      if (hasStartedPolling === false && (currency === 'NGN' || currency === 'GHS')) {
        $charge.poll($this.pollConfig);
      }
      if (currency === 'EGP' || currency === 'KES') {
        PendingView && PendingView.activate.call($this);
      }
    }
  }).call(this));
}
